__turbopack_context__.v({
  "addressInputEndAdornment": "WalletSend-module__e6KGIa__addressInputEndAdornment",
  "altCurrency": "WalletSend-module__e6KGIa__altCurrency",
  "altCurrencyIcon": "WalletSend-module__e6KGIa__altCurrencyIcon",
  "altCurrencyLabel": "WalletSend-module__e6KGIa__altCurrencyLabel",
  "balanceTitle": "WalletSend-module__e6KGIa__balanceTitle",
  "cancelButton": "WalletSend-module__e6KGIa__cancelButton",
  "description": "WalletSend-module__e6KGIa__description",
  "error": "WalletSend-module__e6KGIa__error",
  "form": "WalletSend-module__e6KGIa__form",
  "header": "WalletSend-module__e6KGIa__header",
  "icon": "WalletSend-module__e6KGIa__icon",
  "input": "WalletSend-module__e6KGIa__input",
  "inputEndAdornment": "WalletSend-module__e6KGIa__inputEndAdornment",
  "loading": "WalletSend-module__e6KGIa__loading",
  "receive": "WalletSend-module__e6KGIa__receive",
  "root": "WalletSend-module__e6KGIa__root",
  "sendRcvIconContainer": "WalletSend-module__e6KGIa__sendRcvIconContainer",
});
